<template>
  <div>
    <collapse :title="typeTranslated">
      <b-table
        :data="categories"
        :striped="true"
        :mobile-cards="false"
        :narrowed="true"
        :loading="loading"
        :default-sort="['amount', 'desc']"
      >
        <template slot-scope="props">
          <b-table-column
            field="categories"
            :label="$t('transaction.category')"
            sortable
          >
            {{ props.row.category }}
          </b-table-column>

          <b-table-column
            field="amount"
            :label="$t('transaction.amount')"
            sortable
          >
            {{ props.row.amount }}
          </b-table-column>
        </template>

        <template slot="footer">
          <div class="has-text-right">
            <b-tag size="is-medium" :type="getType">{{ total }}</b-tag>
          </div>
        </template>

        <template slot="empty">
          <section class="section">
            <div class="content has-text-grey has-text-centered">
              <p>
                <b-icon icon="frown" size="is-large"> </b-icon>
              </p>
              <p>
                <i18n v-if="type === 'income'" path="table.noTotalsTracked">
                  {{ $t('table.income') }}
                </i18n>
                <i18n v-if="type === 'expense'" path="table.noTotalsTracked">
                  {{ $t('table.expense') }}
                </i18n>
              </p>
            </div>
          </section>
        </template>
      </b-table>
    </collapse>
  </div>
</template>

<script>
import Collapse from '@/components/Collapse.vue';

export default {
  name: 'categoriesAmountTable',
  components: {
    Collapse
  },
  props: {
    categories: {
      type: Array,
      required: true
    },
    type: {
      type: String
    },
    total: {
      type: Number
    },
    loading: {
      type: Boolean
    }
  },
  computed: {
    getType() {
      return this.type === 'income' ? 'is-success' : 'is-danger';
    },
    typeTranslated() {
      let typeTranslated;
      if (this.type === 'income') {
        typeTranslated = this.$t('table.income');
      } else {
        typeTranslated = this.$t('table.expense');
      }
      return typeTranslated;
    }
  }
};
</script>
